import { Component, OnInit } from '@angular/core';
import { GlobalDataService } from '../providers/global-data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from '../providers/storage.service';
import { AuthService } from '../providers/auth';
import { APPLICATION_SERVER_URL } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false
})
export class HeaderComponent implements OnInit {

  isDevEnvironment: boolean = this.checkIsDevEnvironment();

  constructor(public globalData: GlobalDataService, private http: HttpClient, private storage: StorageService, public auth: AuthService) {

  }

  ngOnInit() {
  }

  checkIsDevEnvironment() {
    const devIndicators = ['sunsetbeachapp', 'localhost', '192.168'];

    return devIndicators.some(indicator =>
      APPLICATION_SERVER_URL.includes(indicator)
    );
  }

}
